module.exports = __webpack_public_path__ + "static/media/dropup.352be9d4.svg";